import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'
import { postMethodConfig } from '@/api/axios'

const state = () => ({
  hitProducts: [],
  isLoading: false
})

const getters = {
  hitProducts: (state) => state.hitProducts,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_HIT_PRODUCTS(state, payload) {
    state.hitProducts = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchHitProducts({ commit, dispatch }, { vm }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get(vm.apiUrl)
      .then((res) => {
        const message = res.data.message
        commit('SET_HIT_PRODUCTS', message.data)
        vm.page = message.current_page
        vm.perPage = message.per_page
        vm.numberOfPages = message.last_page
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  createSingleHitProduct({ dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/hit_product`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/hit-products')
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  deleteSingleHitProduct(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/hit_product/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  fetchSingleHitProduct(_context, { id, vm }) {
    vm.isLoading = true
    axiosWithToken
      .get(`${adminBaseUrl}/hit_product/${id}`)
      .then((res) => {
        const message = res.data.message
        vm.editForm.link = message.link
        vm.editForm.name_en = message.name_en
        vm.editForm.name_ru = message.name_ru
        vm.editForm.price = message.price
        vm.imageUrl = message.image
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  updateSingleHitProduct(_context, { payload, id, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    data.append('_method', 'PUT')

    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/hit_product/${id}`, data, postMethodConfig)
      .then(() => {
        vm.$refs['editSingleHitProductModal'].hide()
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
